
import { call, put, take, takeEvery } from 'redux-saga/effects'
import URI from 'urijs';

import getPromiseCallback from '../utils/getPromiseCallback';

import {
    clearActionType,
    clearOperationNotSuccess,
    clearOperationSuccess,
    checkOperationResult,
    createActionTypes ,
    setOperationStart,
    setOperationSuccess,
    setOperationError,
    setOperationNotSuccess
} from './common';

import { callGet, callPost } from '../serverApi/funcs';

export const CREATE_ACCOUNT_ACTION_TYPE = createActionTypes('auth/CREATE_ACCOUNT');
export const CREATE_ACCOUNT_2_ACTION_TYPE = 'auth/CREATE_ACCOUNT_2';
export const EDIT_ACCOUNT_ACTION_TYPE = createActionTypes('auth/EDIT_ACCOUNT');
export const LOGIN_ACTION_TYPE = createActionTypes('auth/LOGIN');
export const LOGOUT_ACTION_TYPE = createActionTypes('auth/LOGOUT');
export const SEND_ACTIVATION_ACTION_TYPE = createActionTypes('auth/SEND_ACTIVATION');
export const ACTIVATE_ACTION_TYPE = createActionTypes('auth/ACTIVATE');
export const CHANGE_PASSWORD_ACTION_TYPE = createActionTypes('auth/CHANGE_PASSWORD');
export const RESET_PASSWORD_ACTION_TYPE = createActionTypes('auth/RESET_PASSWORD');
export const RESET_PASSWORD_REQUEST_ACTION_TYPE = createActionTypes('auth/RESET_PASSWORD_REQUEST');

const LOCAL_STORAGE_KEY_TOKEN = 'auth_token';

export function getActions(dispatch) {
    return {
        activate: (token, activationCode) => dispatch({
            type: ACTIVATE_ACTION_TYPE.DEFAULT, token, activationCode
        }),
        changePassword: (token, passwordOld, passwordNew) => dispatch({
            type: CHANGE_PASSWORD_ACTION_TYPE.DEFAULT, token, passwordOld, passwordNew
        }),
        createAccount: (username, password, fullName, email) => dispatch({
            type: CREATE_ACCOUNT_2_ACTION_TYPE, username, password, fullName, email
        }),
        editAccount: (token, username, email, fullName) => dispatch({
            type: EDIT_ACCOUNT_ACTION_TYPE.DEFAULT, token, username, email, fullName
        }),
        login: (username, password) => dispatch({
            type: LOGIN_ACTION_TYPE.DEFAULT, username, password
        }),
        logout: (token) => dispatch({
            type: LOGOUT_ACTION_TYPE.DEFAULT, token
        }),
        resetPassword: (rpc, username, password) => dispatch({
            type: RESET_PASSWORD_ACTION_TYPE.DEFAULT, rpc, username, password
        }),
        resetPasswordRequest: (username, email) => dispatch({
            type: RESET_PASSWORD_REQUEST_ACTION_TYPE.DEFAULT, username, email
        }),
        sendActivation: (token) => dispatch({
            type: SEND_ACTIVATION_ACTION_TYPE.DEFAULT, token
        }),
    };
}

function* getToken() {
    let token = (window && window.location) ? getTokenWindowLocation() : null;
    if (!token) {
        token = yield call([localStorage, 'getItem'], LOCAL_STORAGE_KEY_TOKEN);
        if (token) {
            console.log('Token from localStorage:', token);
        }
    }
    return token;
}

function getTokenWindowLocation() {
    let uri = new URI(window.location.href);
    let token = uri.search(true).token;
    if (token) {
        console.log('Token from URL:', token);
        uri.removeSearch('token');
        window.history.pushState('', '', uri.toString());
    }
    return token;
}

function activate(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'activate',
            token: action.token,
            body: {
                activationCode: action.activationCode
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function changePassword(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'changePassword',
            token: action.token,
            body: {
                passwordOld: action.passwordOld,
                passwordNew: action.passwordNew
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function createAccount(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'createAccount',
            body: {
                user: {
                    username: action.username,
                    password: action.password,
                    full_name: action.fullName,
                    email: action.email
                }
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function editAccount(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'editAccount',
            token: action.token,
            body: {
                username: action.username,
                email: action.email,
                fullName: action.fullName
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function login(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'login',
            body: {
                user: {
                    username: action.username,
                    password: action.password
                }
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function logout(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'logout',
            token: action.token,
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function resetPassword(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'resetPassword',
            body: {
                rpc: action.rpc,
                username: action.username,
                password: action.password
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function resetPasswordRequest(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'resetPasswordRequest',
            body: {
                username: action.username,
                email: action.email
            },
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function sendActivation(action) {
    return new Promise((resolve, reject) => {
        callPost({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'sendActivation',
            token: action.token,
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function verify(token) {
    return new Promise((resolve, reject) => {
        callGet({
            baseUrl: '/auth/api',
            module: 'auth',
            name: 'verify',
            token: token,
            callback: getPromiseCallback(resolve, reject)
        });
    });
}

function* redirect(url, options) {
    if (options && options.history && url) {
        if (url.indexOf('#') === -1) {
            yield call([window.location, 'assign'], url);
        } else {
            yield call(options.history.push, url);
        }
    }
}

export function* authFlow(options) {
    if (options && (options.anonymous === true)) {
        console.log('anonymous, auth flow is disabled');
        return;
    }
    let token = yield call(getToken);
    while (true) {
        try {
            let authData = null;
            if (token) {
                yield put({type: LOGIN_ACTION_TYPE.DEFAULT});
                authData = yield call(verify, token);
            } else {
                const loginAction = yield take(LOGIN_ACTION_TYPE.DEFAULT)
                authData = yield call(login, loginAction);
            }
            yield call([localStorage, 'setItem'], LOCAL_STORAGE_KEY_TOKEN, authData.user.token);
            yield put({type: LOGIN_ACTION_TYPE.SUCCESS, data: authData});

            const logoutAction = yield take(LOGOUT_ACTION_TYPE.DEFAULT)
            try {
                const data = yield call(logout, logoutAction);
                yield call([localStorage, 'removeItem'], LOCAL_STORAGE_KEY_TOKEN);
                yield put({type: LOGOUT_ACTION_TYPE.SUCCESS, data: data});

                let afterLogoutUrl = logoutAction.logoutUrl || options.afterLogoutUrl;
                yield call(redirect, afterLogoutUrl, options);
            } catch (error) {
                yield put({type: LOGOUT_ACTION_TYPE.FAILED, error});
            }

        } catch (error) {
            yield put({type: LOGIN_ACTION_TYPE.FAILED, error});
        }

        token = null;
    }
}

function* workCreateAccount(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: CREATE_ACCOUNT_ACTION_TYPE.DEFAULT});
        const data = yield call(createAccount, action);
        yield put({type: CREATE_ACCOUNT_ACTION_TYPE.SUCCESS, data});
        if (data && data.user) {
            yield call(setOperationSuccess, title);
            yield call(clearOperationSuccess);
            yield put({type: LOGIN_ACTION_TYPE.DEFAULT, username: action.username, password: action.password});
        }
        yield call(checkOperationResult, data, {title: title});
    } catch (error) {
        yield put({type: CREATE_ACCOUNT_ACTION_TYPE.FAILED, error});
    }
}

export function* watchCreateAccount(options) {
    yield takeEvery(
        CREATE_ACCOUNT_2_ACTION_TYPE, workCreateAccount,
        options, 'Registrování nového uživatele'
    );
}

function* workSendActivation(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: SEND_ACTIVATION_ACTION_TYPE.LOADING});

        yield put({type: SEND_ACTIVATION_ACTION_TYPE.LOADING});
        const data = yield call(sendActivation, action);
        yield put({type: SEND_ACTIVATION_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data, {title: title});

    } catch (error) {
        yield call(setOperationError, error, SEND_ACTIVATION_ACTION_TYPE);
    }
}

export function* watchSendActivation(options) {
    yield takeEvery(
        SEND_ACTIVATION_ACTION_TYPE.DEFAULT, workSendActivation,
        options, 'Odeslání aktivačního emailu'
    );
}

function* workActivate(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: ACTIVATE_ACTION_TYPE.LOADING});

        yield put({type: ACTIVATE_ACTION_TYPE.LOADING});
        try {
            const data = yield call(activate, action);
            yield put({type: ACTIVATE_ACTION_TYPE.SUCCESS, data});
            yield call(checkOperationResult, data, {title: title});
        } catch (error) {
            yield call(setOperationNotSuccess, title, [{id: 0, title: 'Aktivační kód není platný'}]);
            yield call(clearOperationNotSuccess);
        }
    } catch (error) {
        yield call(setOperationError, error, ACTIVATE_ACTION_TYPE);
    }
}

export function* watchActivate(options) {
    yield takeEvery(
        ACTIVATE_ACTION_TYPE.DEFAULT, workActivate,
        options, 'Aktivování uživatelského účtu'
    );
}

function* workChangePassword(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: CHANGE_PASSWORD_ACTION_TYPE.LOADING});
        const data = yield call(changePassword, action);
        yield put({type: CHANGE_PASSWORD_ACTION_TYPE.SUCCESS, data});
        if (data.success) {
            yield call(redirect, '/', options);
        }
        yield call(checkOperationResult, data, {title: title});
    } catch (error) {
        yield call(setOperationError, error, CHANGE_PASSWORD_ACTION_TYPE);
    }
}

export function* watchChangePassword(options) {
    yield takeEvery(
        CHANGE_PASSWORD_ACTION_TYPE.DEFAULT, workChangePassword,
        options, 'Změna hesla'
    );
}

function* workEditAccount(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: EDIT_ACCOUNT_ACTION_TYPE.LOADING});
        const { type, token, ...params } = action;
        const data = yield call(editAccount, action);
        yield put({type: EDIT_ACCOUNT_ACTION_TYPE.SUCCESS, data, params});
        if (data.success) {
            yield call(redirect, '/', options);
        }
        yield call(checkOperationResult, data, {title: title});
    } catch (error) {
        yield call(setOperationError, error, EDIT_ACCOUNT_ACTION_TYPE);
    }
}

export function* watchEditAccount(options) {
    yield takeEvery(
        EDIT_ACCOUNT_ACTION_TYPE.DEFAULT, workEditAccount,
        options, 'Aktualizace uživatelského účtu'
    );
}

function* workResetPasswordRequest(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: RESET_PASSWORD_REQUEST_ACTION_TYPE.LOADING});
        const data = yield call(resetPasswordRequest, action);
        yield put({type: RESET_PASSWORD_REQUEST_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data, {title: title});
    } catch (error) {
        yield call(setOperationError, error, RESET_PASSWORD_REQUEST_ACTION_TYPE);
    }
}

export function* watchResetPasswordRequest(options) {
    yield takeEvery(
        RESET_PASSWORD_REQUEST_ACTION_TYPE.DEFAULT, workResetPasswordRequest,
        options, 'Odeslání žádosti o obnovu hesla'
    );
}

function* workResetPassword(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: RESET_PASSWORD_ACTION_TYPE.LOADING});
        const data = yield call(resetPassword, action);
        yield put({type: RESET_PASSWORD_ACTION_TYPE.SUCCESS, data});
        if (data.success) {
            yield call(redirect, '/', options);
        }
        yield call(checkOperationResult, data, {title: title});
    } catch (error) {
        yield call(setOperationError, error, RESET_PASSWORD_ACTION_TYPE);
    }
}

export function* watchResetPassword(options) {
    yield takeEvery(
        RESET_PASSWORD_ACTION_TYPE.DEFAULT, workResetPassword,
        options, 'Změna hesla'
    );
}
